import { render, staticRenderFns } from "./IbRequiredRoles.vue?vue&type=template&id=5de5c739"
import script from "./IbRequiredRoles.vue?vue&type=script&lang=js"
export * from "./IbRequiredRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports